/**
 * sl-sbpf.1: Frontend facade for the canonical Custom App CSS contract.
 *
 * The canonical definition lives in @streamlain/view-config (it is shared
 * with the SSR custom-app-viewer bundle and backend materialization). Local
 * const bindings keep the established frontend-core import path visible to
 * webpack's strict export analysis.
 */
import type {
  CustomAppComponentId,
  CustomAppCssVar,
  CustomAppFlagAttr,
  CustomAppShellRoleId,
  CustomAppStateValue,
} from '@streamlain/view-config';
import * as ViewConfig from '@streamlain/view-config';

export const CUSTOM_APP_COMPONENT_ATTR = ViewConfig.CUSTOM_APP_COMPONENT_ATTR;
export const CUSTOM_APP_COMPONENT_ID_VALUES =
  ViewConfig.CUSTOM_APP_COMPONENT_ID_VALUES;
export const CUSTOM_APP_COMPONENT_IDS = ViewConfig.CUSTOM_APP_COMPONENT_IDS;
export const CUSTOM_APP_CSS_VARS = ViewConfig.CUSTOM_APP_CSS_VARS;
export const CUSTOM_APP_FIELD_ATTR = ViewConfig.CUSTOM_APP_FIELD_ATTR;
export const CUSTOM_APP_FIELD_TYPE_ATTR = ViewConfig.CUSTOM_APP_FIELD_TYPE_ATTR;
export const CUSTOM_APP_FLAG_ATTRS = ViewConfig.CUSTOM_APP_FLAG_ATTRS;
export const CUSTOM_APP_LINT_FORBIDDEN_PROPERTIES =
  ViewConfig.CUSTOM_APP_LINT_FORBIDDEN_PROPERTIES;
export const CUSTOM_APP_LINT_FORBIDDEN_SELECTORS =
  ViewConfig.CUSTOM_APP_LINT_FORBIDDEN_SELECTORS;
export const CUSTOM_APP_MOTION_CLASS_PREFIX =
  ViewConfig.CUSTOM_APP_MOTION_CLASS_PREFIX;
export const CUSTOM_APP_MOTION_INDEX_CSS_VAR =
  ViewConfig.CUSTOM_APP_MOTION_INDEX_CSS_VAR;
export const CUSTOM_APP_ROLE_ATTR = ViewConfig.CUSTOM_APP_ROLE_ATTR;
export const CUSTOM_APP_ROOT_ATTRS = ViewConfig.CUSTOM_APP_ROOT_ATTRS;
export const CUSTOM_APP_SCOPE_CLASS = ViewConfig.CUSTOM_APP_SCOPE_CLASS;
export const CUSTOM_APP_SHELL_ROLE_IDS = ViewConfig.CUSTOM_APP_SHELL_ROLE_IDS;
export const CUSTOM_APP_STATE_ATTR = ViewConfig.CUSTOM_APP_STATE_ATTR;
export const CUSTOM_APP_STATE_VALUES = ViewConfig.CUSTOM_APP_STATE_VALUES;

export type {
  CustomAppComponentId,
  CustomAppCssVar,
  CustomAppFlagAttr,
  CustomAppShellRoleId,
  CustomAppStateValue,
};
